import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CaseEventModal, CaseFormModel, CaseNeighbors } from '@/models/case-process.model';
import { ContactModel } from '@/models/contact.model';
import { EmailMessage } from '@/models/email/email-message.model';

export type EmailType = {
  name: string;
  email: string;
};
export type EmailToParamType = {
  status: string;
  to: EmailType[];
  case_id: string;
};
export type MessageParamType = {
  subject: string;
  interaction_id: string;
  message_id: string;
};

interface CaseProcessState {
  formList: CaseFormModel[];
  timelineCaseEventData: CaseEventModal[];
  snapshotContact: ContactModel | null;
  showSendEmail: boolean;
  isNewEmail: boolean;
  emailFromParam: EmailType;
  emailToParam: EmailToParamType;
  currentEmailMessage: EmailMessage[];
  sendMessageParam: MessageParamType;
  sendEmailInCase: boolean;
  caseNeighbors: CaseNeighbors | undefined;
  watchingCurCaseId: string;
  watchingCurCaseAgentIds: string[];
}

const initialState: CaseProcessState = {
  formList: [],
  timelineCaseEventData: [],
  snapshotContact: null,
  showSendEmail: false,
  isNewEmail: false,
  emailFromParam: { name: '', email: '' },
  emailToParam: { status: '', to: [], case_id: '' },
  currentEmailMessage: [],
  sendMessageParam: { subject: '', interaction_id: '', message_id: '' },
  sendEmailInCase: false,
  caseNeighbors: undefined,
  watchingCurCaseId: '',
  watchingCurCaseAgentIds: [],
};

const caseProcess = createSlice({
  name: 'case-process',
  initialState,
  reducers: {
    setCaseFormList: (state, action: PayloadAction<CaseProcessState['formList']>) => {
      state.formList = action.payload;
    },
    setTimelineCaseEventData: (state, action: PayloadAction<CaseProcessState['timelineCaseEventData']>) => {
      state.timelineCaseEventData = action.payload;
    },
    setSnapshotContact: (state, action: PayloadAction<CaseProcessState['snapshotContact']>) => {
      state.snapshotContact = action.payload;
    },
    setShowSendEmail: (state, action: PayloadAction<CaseProcessState['showSendEmail']>) => {
      state.showSendEmail = action.payload;
    },
    setIsNewEmail: (state, action: PayloadAction<CaseProcessState['isNewEmail']>) => {
      state.isNewEmail = action.payload;
    },
    setEmailFromParam: (state, action: PayloadAction<CaseProcessState['emailFromParam']>) => {
      state.emailFromParam = action.payload;
    },
    setEmailToParam: (state, action: PayloadAction<CaseProcessState['emailToParam']>) => {
      state.emailToParam = action.payload;
    },
    setCurrentEmailMessage: (state, action: PayloadAction<CaseProcessState['currentEmailMessage']>) => {
      state.currentEmailMessage = action.payload;
    },
    setSendMessageParam: (state, action: PayloadAction<CaseProcessState['sendMessageParam']>) => {
      state.sendMessageParam = action.payload;
    },
    setSendEmailInCase: (state, action: PayloadAction<CaseProcessState['sendEmailInCase']>) => {
      state.sendEmailInCase = action.payload;
    },
    setCaseNeighbors: (state, action: PayloadAction<CaseNeighbors | undefined>) => {
      state.caseNeighbors = action.payload;
    },
    setWatchingCurCaseId: (state, action: PayloadAction<CaseProcessState['watchingCurCaseId']>) => {
      state.watchingCurCaseId = action.payload;
    },
    setWatchingCurCaseAgentIds: (state, action: PayloadAction<CaseProcessState['watchingCurCaseAgentIds']>) => {
      state.watchingCurCaseAgentIds = action.payload;
    },
  },
});

export const {
  setCaseFormList,
  setTimelineCaseEventData,
  setSnapshotContact,
  setIsNewEmail,
  setEmailFromParam,
  setEmailToParam,
  setSendMessageParam,
  setCurrentEmailMessage,
  setShowSendEmail,
  setSendEmailInCase,
  setCaseNeighbors,
  setWatchingCurCaseId,
  setWatchingCurCaseAgentIds,
} = caseProcess.actions;
export default caseProcess.reducer;
